import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUserDetail } from "../../redux/slice/userSlice";
import dataConstant from "../../constants/dataConstants";

const PageNotFound = () => {
  const navigate = useNavigate();
  const userDetails = useSelector(selectUserDetail);
  const adminSubdomains = process.env.REACT_APP_ADMIN_SUBDOMAIN;
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  return (
    <Box
      flex="1 1 0"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <img
        src="/pagenotfound.svg"
        alt="Page Not Found"
        style={{ maxHeight: "32vh", margin: "0 auto" }}
      />
      <Typography variant="h1" maxWidth="30%" textAlign="center">
        We can't find the page <br /> you're looking for.
      </Typography>
      <Typography variant="body1" maxWidth="30%" textAlign="center" mb={3}>
        Page not found. It may have been moved, removed, or temporarily
        unavailable. Please check the URL or go back home.
      </Typography>
      {adminSubdomains.includes(parts[0]) ? (
        userDetails !== null &&
        (userDetails?.roles === dataConstant.roles.marketer ? (
          <Button variant="contained" onClick={() => navigate("/submission")}>
            Go back submission
          </Button>
        ) : (
          <Button variant="contained" onClick={() => navigate("/dashboard")}>
            Go back dashboard
          </Button>
        ))
      ) : (
        <Button variant="contained" onClick={() => navigate("/clientIntake")}>
          Go back intake form
        </Button>
      )}
    </Box>
  );
};

export default PageNotFound;